import {useState, useRef} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'

import TStyle from 'shared/style/tableStyle'
import DefaultButton from 'shared/ui/DefaultButton'
import useGetStoreTicketTypes from 'entity/store/useGetStoreTicketTypes'
import Pagenation from 'widget/Pagenation'
import TableLoading from 'shared/ui/TableLoading'
import useGetFranchiseManagerTicketList from 'entity/franchise/useGetFranchiseManagerTicketList'
import PaymentCollectionModal from './ui/PaymentCollectionModal'

const MyFranchiseManagerTicketList = () => {
	const navigate = useNavigate()
	const [ticketTypes] = useGetStoreTicketTypes()
	const [ticketList, isLoading, refetchTicketList] =
		useGetFranchiseManagerTicketList()

	const sortedVoucherTypes =
		ticketTypes?.data?.ticket_types?.sort((a, b) => a.idx - b.idx) || []

	const [selectedManagerId, setSelectedManagerId] = useState(null)

	const onClickOpenModal = (e, idx) => {
		e.stopPropagation()
		setSelectedManagerId(idx)
	}

	const btnList = []
	btnList.push({
		label: '거래 내역',
		clickEvent: () => navigate('/ticket-manager/transaction-history'),
		deactive: false,
	})

	const sizeList = ['short', 'expand', 'expand', 'long', 'long', 'medium']
	const tableHeadList = [
		'IDX',
		'매장명',
		'매니저 이름',
		'매니저 연락처',
		'보유 수량',
		'',
	]

	const formatExpirationDays = (days) => {
		if (days === null) return 'Unlimited'
		return `${days} days`
	}

	const handleModalClose = () => {
		setSelectedManagerId(null)
		refetchTicketList()
	}

	return (
		<>
			{selectedManagerId && (
				<PaymentCollectionModal
					managerId={selectedManagerId}
					closeEvent={handleModalClose}
				/>
			)}

			<Style.Wrapper>
				<MainHeader btnList={btnList}>매장 이용권 관리</MainHeader>
				<Style.AreaDiv>
					<Style.AreaTitle>
						<h2>매장 이용권 유형</h2>
						<DefaultButton
							fitWidth
							expandHeight
							small
							clickEvent={() => navigate('/ticket-manager/edit')}
						>
							매장 이용권 수정
						</DefaultButton>
					</Style.AreaTitle>

					<Style.VoucherTableDiv>
						{sortedVoucherTypes.map((voucher, index) => (
							<Style.VoucherItem key={voucher.idx}>
								<Style.VoucherRow>
									<Style.VoucherLabelLeft>{index + 1}</Style.VoucherLabelLeft>
									<p>{voucher.name}</p>
								</Style.VoucherRow>

								<Style.VoucherRowRight>
									<Style.VoucherLabelRight>만료 시간</Style.VoucherLabelRight>
									<p>{formatExpirationDays(voucher.expiration_days)}</p>
								</Style.VoucherRowRight>
							</Style.VoucherItem>
						))}

						{sortedVoucherTypes?.length === 0 && (
							<Style.VoucherItem>
								<Style.VoucherRow>
									<Style.VoucherLabelLeft>-</Style.VoucherLabelLeft>
									<p>-</p>
								</Style.VoucherRow>

								<Style.VoucherRowRight>
									<Style.VoucherLabelRight>만료 시간</Style.VoucherLabelRight>
									<p>-</p>
								</Style.VoucherRowRight>
							</Style.VoucherItem>
						)}
					</Style.VoucherTableDiv>
				</Style.AreaDiv>

				<Style.AreaDiv>
					<h2>매장 목록</h2>

					<TableLoading isLoading={isLoading}>
						<TStyle.TableDiv>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										{elem}
									</TStyle.Data>
								))}
							</TStyle.TableRow>

							{ticketList?.data?.items?.map((item, index) => (
								<TStyle.TableRow
									key={index}
									$odd={index % 2 === 1}
									onClick={() => navigate(`store/${item?.idx}/detail`)}
								>
									<TStyle.Data $size={sizeList[0]}>{item.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>
										{item.storeName}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>
										{item.managerName}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>{item.contact}</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>
										<TStyle.Count>
											<p>총합: {item?.total}</p>
											{item?.ticket_detail?.length ? <hr /> : <></>}
											{item?.ticket_detail?.map((detail) => (
												<p>
													<span>{detail.name}: </span>
													<span>{detail.number}</span>
												</p>
											))}
										</TStyle.Count>
									</TStyle.Data>
									<TStyle.Data $size={sizeList[5]}>
										<DefaultButton
											small
											clickEvent={(e) => onClickOpenModal(e, item?.idx)}
										>
											이용권 관리
										</DefaultButton>
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableDiv>
					</TableLoading>
				</Style.AreaDiv>

				<Pagenation maxPage={ticketList?.data?.maxPage} />
			</Style.Wrapper>
		</>
	)
}

export default MyFranchiseManagerTicketList
